import {
  DELETE_RESIDENT_DOCUMENT,
  DELETE_RESIDENT_DOCUMENT_FAILURE,
  DELETE_RESIDENT_DOCUMENT_SUCCESS,
  GET_RESIDENT_DOCUMENTS,
  GET_RESIDENT_DOCUMENTS_FAILURE,
  GET_RESIDENT_DOCUMENTS_SUCCESS,
  SAVE_RESIDENT_DOCUMENT,
  SAVE_RESIDENT_DOCUMENT_FAILURE,
  SAVE_RESIDENT_DOCUMENT_SUCCESS,
} from "./constants";

// GET RESIDENT DOCUMENTS
export const getResidentDocuments = (payload, onSuccess) => ({
  type: GET_RESIDENT_DOCUMENTS,
  payload,
  onSuccess,
});
export const getResidentDocumentsSuccess = (payload) => ({
  type: GET_RESIDENT_DOCUMENTS_SUCCESS,
  payload,
});
export const getResidentDocumentsFailure = (payload) => ({
  type: GET_RESIDENT_DOCUMENTS_FAILURE,
  payload,
});

// SAVE RESIDENT DOCUMENT
export const saveResidentDocument = (payload, onSuccess) => ({
  type: SAVE_RESIDENT_DOCUMENT,
  payload,
  onSuccess,
});
export const saveResidentDocumentSuccess = (payload) => ({
  type: SAVE_RESIDENT_DOCUMENT_SUCCESS,
  payload,
});
export const saveResidentDocumentFailure = (payload) => ({
  type: SAVE_RESIDENT_DOCUMENT_FAILURE,
  payload,
});

// DELETE RESIDENT DOCUMENT
export const deleteResidentDocument = (payload, onDelete) => ({
  type: DELETE_RESIDENT_DOCUMENT,
  payload,
  onDelete,
});
export const deleteResidentDocumentSuccess = (payload) => ({
  type: DELETE_RESIDENT_DOCUMENT_SUCCESS,
  payload,
});
export const deleteResidentDocumentFailure = (payload) => ({
  type: DELETE_RESIDENT_DOCUMENT_FAILURE,
  payload,
});
